import React, { useEffect } from 'react';
import { StepType, useTour } from '../../Other/tour';
import { Box, Button, InlineStack, Text, BlockStack } from '@shopify/polaris';
import { DI } from '../../../Core';
import useContextLayer from './Context/helper';
import useContainerState from './Context/ContainerState';
import { isAdminLoggedIn } from '../Panel/index';
import { t } from 'i18next';

const TourListingSteps = (props: any) => {
    const { setSteps, setIsOpen, setTourLoading, setCurrentStep, currentStep } = useTour()
    const { state, dispatch } = useContextLayer();
    const { containerState } = useContainerState();
    const isVariant = !!props.match?.s_id

    const attributesfilled = () => {
        if (props?.categoryProductType?.oldOrNew === 'new') {
            return props?.saveJSONData?.saveJSONFeed?.()?.hasError
        }
        let categories = state?.category_settings?.attributes_mapping?.required_attribute ?? [];
        let opt_categories = state?.category_settings?.attributes_mapping?.optional_attribute ?? [];

        let hasError = false
        if (categories.length > 0) {
            categories.map((att: any) => {
                !hasError && (hasError = !(att?.shopify_select?.value?.value === 'custom' ? !!att?.custom_text : att?.shopify_select?.value?.value === 'Search' ? !!att?.shopify_attribute?.value?.value : att?.shopify_select?.value?.value === "recommendation" ? !!att?.recommendation?.value?.value : false))
            })
        }
        if (opt_categories.length > 0) {
            opt_categories.map((att: any) => {
                let attribute = att?.amazon_attribute?.value;
                !hasError && (hasError = !(attribute?.shopify_select?.value?.value && (attribute?.shopify_select?.value?.value === 'custom' ? !!attribute?.custom_text : attribute?.shopify_select?.value?.value === 'Search' ? !!attribute?.shopify_attribute?.value?.value : attribute?.shopify_select?.value?.value === "recommendation" ? !!attribute?.recommendation?.value?.value : false)))
            })
        }

        if (containerState?.product_type?.variantEdit) {
            if (!state?.variation_theme?.value?.value) {
                !hasError && (hasError = true);
            } else {
                let errorInVariationFields = state?.['variation_theme_attributes']?.some((att: any) => {
                    if (att?.recommendation?.options?.length > 0) {
                        state?.variants?.map((variant: any) => {
                            variant?.variation_theme_fields?.[att?.value] !== undefined && !hasError && (hasError = !variant?.variation_theme_fields?.[att?.value])
                        })
                    }
                    return !att?.shopify_attribute?.value?.value
                });
                !hasError && (hasError = errorInVariationFields)
            }
        }
        return hasError
    }

    const saveTourData = () => {
        props.di.POST('connector/config/saveConfig', {
            "data": [
                {
                    data: JSON.parse(JSON.stringify({ listing_tour_1_visited: true, listing_tour_2_visited: true, listing_tour_3_visited: false })),
                    group_code: "tour"
                }
            ]
        }).then((response: any) => {
            setCurrentStep(-1)
            setIsOpen(false)
            if (response.success) return;
            props.error('Failed to end tour')
        })
    }

    const endTour = () => {
        props.di.POST('connector/config/saveConfig', {
            data: [
                {
                    data: JSON.parse(
                        JSON.stringify(
                            {
                                listing_tour_1_visited: true,
                                listing_tour_2_visited: true,
                                listing_tour_3_visited: true,
                            }
                        )
                    ),
                    group_code: 'tour',
                },
            ],
        }
        )
            .then((response: any) => {
                setCurrentStep(-1);
                setIsOpen(false);
                if (response.success) return;
                props.error(t('Failed to end tour'));
            });
    }

    const steps: StepType[] = [
        {
            selector: 'ced-tour---1',
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Edit Product")}</Text>
                        <Text as='p'>{t("On the Product Edit page, you can modify listing type, title, description, price, inventory, SKU, barcode, and images. You can either use Shopify settings or customize them. Additionally, fulfillment type, handling time, category, and attributes can be managed through the app.")}</Text>
                    </BlockStack>
                </Box>
            </div>,
            hideActions: {
                back: true,
            },
            OnClose() {
                endTour();
            },
            stepInteraction: true,
            footer(p) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button variant='plain' tone='critical' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                {/* <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button> */}
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            },
        },
        ...(!isVariant ? [{
            selector: '#tour_listing_type',
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Edit Product")}</Text>
                        <Text as="p">{t("Here, you can check the product's listing type. There are two types: 'New listing,' which uploads your product as new, and 'Offer listing,' which lists product using existing details. In 'New Listings’, you can edit everything, while in 'Offer' listings, you can only modify fulfillment type, price, inventory, SKU, barcode, and attributes.")}</Text>
                    </BlockStack>
                </Box>
            </div>,
            // hideActions: {
            //     back: true,
            // },
            OnClose() {
                endTour();
            },
            // stepInteraction: true,
            footer(p: any) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button variant='plain' tone='critical' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            },
        }] : []),
        // ...(error.parent > 0 || error.variant > 0) && Object.keys(state).length > 0 ? [
        //     {
        //         selector: '#tour_errors',
        //         position: 'left',
        //         content: <div style={{ maxWidth: 400 }}>
        //             <Box padding="300">
        //                 <BlockStack gap="200">
        //                     <Text as='h2' variant='headingMd'>{t("Edit Product")}</Text>
        //                     <Text as="p">Click on View Error button to view errors</Text>
        //                 </BlockStack>
        //             </Box>
        //         </div>,
        //         hideActions: {
        //             next: true,
        //         },
        //         stepInteraction: true,
        // OnClose() {
        //     endTour();
        // },
        //     },
        //     {
        //         selector: '.Polaris-Modal-Dialog__Modal #tour_errors',
        //         position: 'left',
        //         content: <div style={{ maxWidth: 400 }}>
        //             <Box padding="300">
        //                 <BlockStack gap="200">
        //                     <Text as='h2' variant='headingMd'>{t("Edit Product")}</Text>
        //                     <Text as="p">Errors related to product or its variants can be seen in this section</Text>
        //                 </BlockStack>
        //             </Box>
        //         </div>,
        //         stepInteraction: true,
        // OnClose() {
        //     endTour();
        // },
        //     }
        // ] : [],
        ...(containerState['product_type']['variantEdit'] || !containerState.initialProductData['hasVariants'] ? [
            {
                selector: '#tour_fullfilment',
                position: 'left',
                content: <div style={{ maxWidth: 350 }}>
                    <Box padding="300">
                        <BlockStack gap="200">
                            <Text as='h2' variant='headingMd'>{t("Edit Product")}</Text>
                            <Text as="p">{t("You can view and modify your product's fulfillment type here.")}</Text>
                        </BlockStack>
                    </Box>
                </div>,
                hideActions: {
                    back: isVariant,
                },
                OnClose() {
                    endTour();
                },
                stepInteraction: true,
                footer(p: any) {
                    return <div style={{ maxWidth: 400 }}>
                        <Box padding='300'>
                            <InlineStack align='space-between'>
                                <Button variant='plain' tone='critical' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                                <InlineStack gap='400'>
                                    {isVariant && <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>}
                                    <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }}>{t("Next")}</Button>
                                </InlineStack>
                            </InlineStack>
                        </Box>
                    </div>
                },
            },
        ] : []),

        ...(state?.['listing_type'] == 'new_listing' && !isVariant ? [
            // {
            //     selector: '#tour_AI_card',
            //     position: 'left',
            //     content: <div style={{ maxWidth: 350 }}>
            //         <Box padding="300">
            //             <BlockStack gap="200">
            //                 <Text as='h2' variant='headingMd'>{t("Edit Product")}</Text>
            //                 <Text as="p">You now also apply AI when editing product.</Text>
            //             </BlockStack>
            //         </Box>
            //     </div>,
            // },
            // OnClose() {
            //     endTour();
            // },
            {
                selector: '#tour_title',
                position: 'left',
                content: <div style={{ maxWidth: 350 }}>
                    <Box padding="300">
                        <BlockStack gap="200">
                            <Text as='h2' variant='headingMd'>{t("Edit Product")}</Text>
                            <Text as="p">{t("You can either use the same product title as on Shopify or customize it for Amazon.")}</Text>
                        </BlockStack>
                    </Box>
                </div>,
                OnClose() {
                    endTour();
                },
                stepInteraction: true,
                footer(p: any) {
                    return <div style={{ maxWidth: 400 }}>
                        <Box padding='300'>
                            <InlineStack align='space-between'>
                                <Button variant='plain' tone='critical' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                                <InlineStack gap='400'>
                                    <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                    <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }}>{t("Next")}</Button>
                                </InlineStack>
                            </InlineStack>
                        </Box>
                    </div>
                },
            },
            {
                selector: '#tour_desc',
                position: 'left',
                content: <div style={{ maxWidth: 350 }}>
                    <Box padding="300">
                        <BlockStack gap="200">
                            <Text as='h2' variant='headingMd'>{t("Edit Product")}</Text>
                            <Text as="p">{t("You can either use same product description as on Shopify or add a custom description for Amazon.")}</Text>
                        </BlockStack>
                    </Box>
                </div>,
                OnClose() {
                    endTour();
                },
                stepInteraction: true,
                footer(p: any) {
                    return <div style={{ maxWidth: 400 }}>
                        <Box padding='300'>
                            <InlineStack align='space-between'>
                                <Button variant='plain' tone='critical' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                                <InlineStack gap='400'>
                                    <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                    <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }}>{t("Next")}</Button>
                                </InlineStack>
                            </InlineStack>
                        </Box>
                    </div>
                },
            },
            {
                selector: '#tour_handling_time',
                position: 'left',
                content: <div style={{ maxWidth: 350 }}>
                    <Box padding="300">
                        <BlockStack gap="200">
                            <Text as='h2' variant='headingMd'>{t("Edit Product")}</Text>
                            <Text as="p">{t("You have the option to use the handling time from the saved template or set a custom handling time.")}</Text>
                        </BlockStack>
                    </Box>
                </div>,
                OnClose() {
                    endTour();
                },
                stepInteraction: true,
                footer(p: any) {
                    return <div style={{ maxWidth: 400 }}>
                        <Box padding='300'>
                            <InlineStack align='space-between'>
                                <Button variant='plain' tone='critical' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                                <InlineStack gap='400'>
                                    <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                    <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }}>{t("Next")}</Button>
                                </InlineStack>
                            </InlineStack>
                        </Box>
                    </div>
                },
            }
        ] : []),
        ...(containerState['product_type']['variantEdit'] || !containerState.initialProductData['hasVariants'] ? [
            {
                selector: '#tour_prices',
                position: 'left',
                content: <div style={{ maxWidth: 350 }}>
                    <Box padding="300">
                        <BlockStack gap="200">
                            <Text as='h2' variant='headingMd'>{t("Edit Product")}</Text>
                            <Text as="p">{t("You can either use the same product price as on Shopify or customize it for Amazon.")}</Text>
                        </BlockStack>
                    </Box>
                </div>,
                hideActions: {
                    back: isVariant,
                },
                OnClose() {
                    endTour();
                },
                stepInteraction: true,
                footer(p: any) {
                    return <div style={{ maxWidth: 400 }}>
                        <Box padding='300'>
                            <InlineStack align='space-between'>
                                <Button variant='plain' tone='critical' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                                <InlineStack gap='400'>
                                    {isVariant && <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>}
                                    <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }}>{t("Next")}</Button>
                                </InlineStack>
                            </InlineStack>
                        </Box>
                    </div>
                },
            },
            {
                selector: '#tour_inventory',
                position: 'left',
                content: <div style={{ maxWidth: 350 }}>
                    <Box padding="300">
                        <BlockStack gap="200">
                            <Text as='h2' variant='headingMd'>{t("Edit Product")}</Text>
                            <Text as="p">{t("You can either use the same product inventory as on Shopify or customize it for Amazon.")}</Text>
                        </BlockStack>
                    </Box>
                </div>,
                OnClose() {
                    endTour();
                },
                stepInteraction: true,
                footer(p: any) {
                    return <div style={{ maxWidth: 400 }}>
                        <Box padding='300'>
                            <InlineStack align='space-between'>
                                <Button variant='plain' tone='critical' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                                <InlineStack gap='400'>
                                    <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                    <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }}>{t("Next")}</Button>
                                </InlineStack>
                            </InlineStack>
                        </Box>
                    </div>
                },
            }
        ] : []),
        ...(state?.['listing_type'] == 'new_listing' || containerState['product_type']['variantEdit'] || containerState['initialProductData']['type'] === "simple" ? [
            {
                selector: '#tour_sku',
                position: 'left',
                content: <div style={{ maxWidth: 350 }}>
                    <Box padding="300">
                        <BlockStack gap="200">
                            <Text as='h2' variant='headingMd'>{t("Edit Product")}</Text>
                            <Text as="p">{t("You can either use the same product SKU as on Shopify or customize it for Amazon.")}</Text>
                        </BlockStack>
                    </Box>
                </div>,
                OnClose() {
                    endTour();
                },
                stepInteraction: true,
                footer(p: any) {
                    return <div style={{ maxWidth: 400 }}>
                        <Box padding='300'>
                            <InlineStack align='space-between'>
                                <Button variant='plain' tone='critical' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                                <InlineStack gap='400'>
                                    <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                    <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }}>{t("Next")}</Button>
                                </InlineStack>
                            </InlineStack>
                        </Box>
                    </div>
                },
            }, {
                selector: '#tour_barcode',
                position: 'left',
                content: <div style={{ maxWidth: 350 }}>
                    <Box padding="300">
                        <BlockStack gap="200">
                            <Text as='h2' variant='headingMd'>{t("Edit Product")}</Text>
                            <Text as="p">{t("You can either use the same barcode as on Shopify or customize it for Amazon.")}</Text>
                        </BlockStack>
                    </Box>
                </div>,
                OnClose() {
                    endTour();
                },
                stepInteraction: true,
                footer(p: any) {
                    return <div style={{ maxWidth: 400 }}>
                        <Box padding='300'>
                            <InlineStack align='space-between'>
                                <Button variant='plain' tone='critical' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                                <InlineStack gap='400'>
                                    <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                    <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }}>{t("Next")}</Button>
                                </InlineStack>
                            </InlineStack>
                        </Box>
                    </div>
                },
            }
        ] : []),
        ...(state?.['listing_type'] != 'offer_listing' && !containerState['product_type']['variantEdit'] ? [
            {
                selector: state?.['selection_type']?.['category_settings'] === 'default' ? '[for=tour_category_default]' : '#tour_category_edit',
                position: 'left',
                content: <div style={{ maxWidth: 400 }}>
                    <Box padding="300">
                        <BlockStack gap="200">
                            <Text as='h2' variant='headingMd'>{t("Edit Product")}</Text>
                            {state?.['selection_type']?.['category_settings'] === 'default' ?
                                <Text as="p">
                                    {t("As this product already has a template assigned to it, the categories and attributes specified in the template will be automatically applied to this product.")}
                                </Text>
                                :
                                <>
                                    <Text as="p">
                                        {t("Now, please choose a category from the provided list. Once you've made your category selection, you'll need to fill in details of all required attributes.")}
                                    </Text>
                                    {state?.category_settings?.primary_category === '' || state?.category_settings?.sub_category === '' && <Text as="p">
                                        {t("Note: To proceed, ensure that you select a category first, and then the")} <Text as='span' fontWeight='semibold'>{t("Next")}</Text> {t("button will become accessible. Simply click it to continue the tour")}
                                    </Text>}
                                </>
                            }
                        </BlockStack>
                    </Box>
                </div>,
                hideActions: {
                    next: state?.category_settings?.primary_category === '' || state?.category_settings?.sub_category === '',
                },
                stepInteraction: state?.['selection_type']?.['category_settings'] !== 'default',
                padding: { mask: [25, 5, 50, 5] },
                OnClose() {
                    endTour();
                },
                footer(p: any) {
                    return <div style={{ maxWidth: 400 }}>
                        <Box padding='300'>
                            <InlineStack align='space-between'>
                                <Button variant='plain' tone='critical' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                                <InlineStack gap='400'>
                                    <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                    <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }} disabled={state?.category_settings?.primary_category === '' || state?.category_settings?.sub_category === ''}>{t("Next")}</Button>
                                </InlineStack>
                            </InlineStack>
                        </Box>
                    </div>
                },
            }
        ] : []),
        ...(isVariant ? [{
            selector: '#tour_add_variant_attributes',
            position: 'left',
            content: <div style={{ maxWidth: 350 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Edit Product")}</Text>
                        <Text as="p">{t("You can also add aditional attributes to your variants.")}</Text>
                    </BlockStack>
                </Box>
            </div>,
            OnClose() {
                endTour();
            },
            stepInteraction: true,
            footer(p: any) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button variant='plain' tone='critical' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            },
        }] : []),
        ...((state?.selection_type?.category_settings === 'custom' || state?.['listing_type'] === 'offer_listing') && (state?.['category_settings']?.['attributes_mapping']?.['required_attribute']?.length > 0 || props?.JSONFeedAttributesData) ? [
            {
                selector: '#tour_attribute',
                position: 'left',
                content: <div style={{ maxWidth: 400 }}>
                    <Box padding="300">
                        <BlockStack gap="200">
                            <Text as='h2' variant='headingMd'>{t("Edit Product")}</Text>
                            <Text as="p">{t("Note to fill all the required attributes before proceeding further.")}</Text>
                        </BlockStack>
                    </Box>
                </div>,
                hideActions: {
                    next: true,
                },
                padding: { mask: [25, 5, 25, 5] },
                stepInteraction: state?.['selection_type']?.['category_settings'] !== 'default',
                OnClose() {
                    endTour();
                },
                OnNext() {
                    setCurrentStep(a => a + 3);
                },
                footer(p: any) {
                    return <div style={{ maxWidth: 400 }}>
                        <Box padding='300'>
                            <InlineStack align='space-between'>
                                <Button variant='plain' tone='critical' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                                <InlineStack gap='400'>
                                    <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                    <Button size='slim' variant='primary' onClick={() => { p?.nextClick(); }} disabled={attributesfilled()}>{t("Next")}</Button>
                                </InlineStack>
                            </InlineStack>
                        </Box>
                    </div>
                },
            }, {
                selector: '.Polaris-Modal-Dialog__Modal:has(#optional_tour_attribte)',
                position: 'left',
                content: <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <BlockStack gap='200'>
                            <Text as='h2' variant='headingMd'>{t("Edit Product")}</Text>
                            <Text as="p">{t("Add optional attributes via this modal.")}</Text>
                        </BlockStack>
                    </Box>
                </div>,
                hideActions: {
                    next: true,
                    back: true
                },
                stepInteraction: state?.['selection_type']?.['category_settings'] !== 'default',
                OnClose() {
                    endTour();
                },
                padding: 0,
                footer(p: any) {
                    return <div style={{ maxWidth: 400 }}>
                        <Box padding='300'>
                            <InlineStack align='space-between'>
                                <Button tone='critical' variant='plain' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                                <InlineStack gap='400'>
                                    {/* <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button> */}
                                    <Button size='slim' variant='primary' onClick={() => { p?.nextClick(); }} disabled>{t("Next")}</Button>
                                </InlineStack>
                            </InlineStack>
                        </Box>
                    </div>
                },
            },{
                selector: '.Polaris-Modal-Dialog__Modal:has(#fetch_tour_attribte)',
                position: 'left',
                content: <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <BlockStack gap='200'>
                            <Text as='h2' variant='headingMd'>{t("Edit Product")}</Text>
                            <Text as="p">{t("Fetch data from amazon")}</Text>
                        </BlockStack>
                    </Box>
                </div>,
                hideActions: {
                    next: true,
                    back: true
                },
                stepInteraction: state?.['selection_type']?.['category_settings'] !== 'default',
                OnClose() {
                    endTour();
                },
                padding: 0,
                footer(p: any) {
                    return <div style={{ maxWidth: 400 }}>
                        <Box padding='300'>
                            <InlineStack align='space-between'>
                                <Button tone='critical' variant='plain' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                                <InlineStack gap='400'>
                                    {/* <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button> */}
                                    <Button size='slim' variant='primary' onClick={() => { p?.nextClick(); }} disabled>{t("Next")}</Button>
                                </InlineStack>
                            </InlineStack>
                        </Box>
                    </div>
                },
            }, {
                selector: '.Polaris-Modal-Dialog__Modal:has(#variant_modal_tour)',
                position: 'left',
                content: <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <BlockStack gap='200'>
                            <Text as='h2' variant='headingMd'>{t("Edit Product")}</Text>
                            <Text as="p">Map all variants.</Text>
                        </BlockStack>
                    </Box>
                </div>,
                hideActions: {
                    next: true,
                    back: true
                },
                stepInteraction: state?.['selection_type']?.['category_settings'] !== 'default',
                OnClose() {
                    endTour();
                },
                padding: 0,
                footer(p: any) {
                    return <div style={{ maxWidth: 400 }}>
                        <Box padding='300'>
                            <InlineStack align='space-between'>
                                <Button tone='critical' variant='plain' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                                <InlineStack gap='400'>
                                    {/* <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button> */}
                                    <Button size='slim' variant='primary' onClick={() => { p?.nextClick(); }} disabled>{t("Next")}</Button>
                                </InlineStack>
                            </InlineStack>
                        </Box>
                    </div>
                },
            }
        ] : []),
        ...(state?.['listing_type'] == 'new_listing' ? [
            {
                selector: '#tour_images',
                position: 'left',
                content: <div style={{ maxWidth: 350 }}>
                    <Box padding="300">
                        <BlockStack gap="200">
                            <Text as='h2' variant='headingMd'>{t("Edit Product")}</Text>
                            <Text as="p">{t("You can either use the same product images as on Shopify or customize it for Amazon.")}</Text>
                        </BlockStack>
                    </Box>
                </div>,
                OnClose() {
                    endTour();
                },
                OnBack() {
                    setCurrentStep(a => a - 3);
                },
                hideActions: {
                    back: true
                },
                stepInteraction: true,
                footer(p: any) {
                    return <div style={{ maxWidth: 400 }}>
                        <Box padding='300'>
                            <InlineStack align='space-between'>
                                <Button variant='plain' tone='critical' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                                <InlineStack gap='400'>
                                    <Button size='slim' onClick={() => { p?.backClick(); }}>{t("Back")}</Button>
                                    <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }}>{t("Next")}</Button>
                                </InlineStack>
                            </InlineStack>
                        </Box>
                    </div>
                },
            }
        ] : []),
        ...(!containerState['product_type']['variantEdit'] && containerState.initialProductData['hasVariants'] ? [
            {
                selector: '#tour_variants_grid',
                content: <div style={{ maxWidth: 400 }}>
                    <Box padding="300">
                        <BlockStack gap="200">
                            <Text as='h2' variant='headingMd'>{t("Edit Product")}</Text>
                            <Text as="p">{t("Find all of the available variants related to the product here.")}</Text>
                        </BlockStack>
                    </Box>
                </div>,
                position: 'top',
                onNext: () => {
                    // setAllowNavigation(false)
                },
                OnClose() {
                    endTour();
                },
                // stepInteraction: true,
                footer(p: any) {
                    return <div style={{ maxWidth: 400 }}>
                        <Box padding='300'>
                            <InlineStack align='space-between'>
                                <Button variant='plain' tone='critical' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                                <InlineStack gap='400'>
                                    <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                    <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }}>{t("Next")}</Button>
                                </InlineStack>
                            </InlineStack>
                        </Box>
                    </div>
                },
            },
            // {
            //     selector: '#tour_variant_0',
            //     content: <div style={{ maxWidth: 400 }}>
            //         <Box padding="300">
            //             <BlockStack gap="200">
            //                 <Text as='h2' variant='headingMd'>{t("Edit Product")}</Text>
            //                 <Text as="p">Here, if you feel the need, add more attributes to the variant.</Text>
            //             </BlockStack>
            //         </Box>
            //     </div>,
            //     position: 'top',
            //     // stepInteraction: true,
            //     // reroute: 'panel/user/product/:c_id/variant',
            //     OnClose() {
            //         endTour();
            //     },
            // },
        ] : []),
        // ...(state?.['listing_type'] == 'new_listing' ? [
        // {
        //     selector: '#tour_listing_score',
        //     position: 'left',
        //     content: <div style={{ maxWidth: 350 }}>
        //         <Box padding="300">
        //             <BlockStack gap="200">
        //                 <Text as='h2' variant='headingMd'>{t("Edit Product")}</Text>
        //                 <Text as="p">In case you have applied AI in your tour, your listing score will be shown here and you can see best practises for applying AI here.</Text>
        //             </BlockStack>
        //         </Box>
        //     </div>,
        // },
        // OnClose() {
        //     endTour();
        // },
        // ] : []),
        {
            selector: '#save',
            content: <div style={{ maxWidth: 400 }}>
                <Box padding="300">
                    <BlockStack gap="200">
                        <Text as='h2' variant='headingMd'>{t("Edit Product")}</Text>
                        <Text as="p">{t("If you have made any changes, please save those changes before proceeding. After saving, you can click")} <Text as='span' fontWeight='semibold'>{t("Next")}</Text> {t("to continue with the tour.")}</Text>
                    </BlockStack>
                </Box>
            </div>,
            OnNext: () => {
                saveTourData();
                setIsOpen(false);
                setTourLoading(false);
                props.history('/panel/user/product')
                props.di.globalState.set('uploadTour', JSON.stringify({ part: '3' }));
            },
            nextIsClose: false,
            position: 'top',
            OnClose() {
                endTour();
            },
            hideActions: {
                next: (containerState['showSavebar'] && (process.env.REACT_APP_PROD === "0" || isAdminLoggedIn()))
            },
            footer(p: any) {
                return <div style={{ maxWidth: 400 }}>
                    <Box padding='300'>
                        <InlineStack align='space-between'>
                            <Button variant='plain' tone='critical' removeUnderline onClick={() => { p?.closeClickHandler() }}>{t("End Tour")}</Button>
                            <InlineStack gap='400'>
                                <Button size='slim' onClick={() => { p?.backClick() }}>{t("Back")}</Button>
                                <Button size='slim' variant='primary' onClick={() => { p?.nextClick() }} disabled={(containerState['showSavebar'] && (process.env.REACT_APP_PROD === "0" || isAdminLoggedIn()))}>{t("Next")}</Button>
                            </InlineStack>
                        </InlineStack>
                    </Box>
                </div>
            },
        }
    ] as StepType[]

    useEffect(() => {
        if (state?.initialComponentState?.start_tour && window.innerWidth > 500) {
            setSteps?.(steps)
            setIsOpen(true)
            setCurrentStep((+props.di.globalState.get('edit_tour_current_step')) || 0)
        } else {
            setIsOpen(false)
            setCurrentStep(-1)
        }
    }, [state?.initialComponentState?.start_tour])

    useEffect(() => {
        setTourLoading(containerState?.loaders?.['required_attribute'] && state?.['category_settings']?.['primary_category'])
        setSteps?.([...steps])
    }, [containerState?.loaders?.['required_attribute'], state?.['category_settings']?.['primary_category'], containerState['product_type']['variantEdit'], state?.['category_settings']?.attributes_mapping?.required_attribute, state?.variation_theme_attributes, state?.variant, props?.categoryProductType?.currentData, props?.saveJSONData])

    return null;
};

export default DI(TourListingSteps);